var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mw-calendar" },
    [
      _c(
        _vm.view,
        _vm._g(
          {
            ref: "currentViewRef",
            tag: "component",
            attrs: { events: _vm.events, currentDate: _vm.date },
            on: { gotoDate: _vm.gotoDate, changeView: _vm.changeView },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }